import { useState } from 'react'

import {
  Json,
  Button,
  Textarea,
  LegacyPage,
  Panels,
  Bar,
  LoadingContainer,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalImportTemplates } from 'core/types'

const CompanyImportTemplates = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const [body, setBody] = useState<string>('')

  const {
    mutateAsync: importTemplates,
    isPending,
    data: response,
    error,
  } = useInternalImportTemplates({ companyId })

  const handleImport = async () => {
    try {
      const parsedBody = JSON.parse(body)
      await importTemplates(parsedBody)
    } catch (e) {
      console.error('Failed to parse JSON input', e)
    }
  }

  return (
    <Panels header={<Bar title='Import Templates' />}>
      <LoadingContainer error={error} isLoading={isPending}>
        <LegacyPage.Full>
          <Textarea
            label='Templates (usually paste from file in peach/peach repo)'
            onChange={setBody}
            value={body}
          />
          <Button onClick={handleImport}>Import Templates</Button>
          {response && <Json json={response} title='Response' />}
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyImportTemplates
